import { getFallbackMarblePhoneNumber } from "@/lib/modules/communications/utils";

/** User-facing copy when several portal accounts share one phone number. */
export const PORTAL_OTP_PHONE_MULTIPLE_ACCOUNTS_MESSAGE =
  "We found multiple accounts for this phone number. Try logging in with your email address.";

/** User-facing copy when several portal accounts share one email address. */
export const portalOtpEmailMultipleAccountsMessage = () =>
  `We found multiple accounts for this email address. Please contact support at ${getFallbackMarblePhoneNumber({ formatted: true })}.`;

export const getMaskedEmail = (email: string) => {
  return email.charAt(0) + "*".repeat(Math.max(0, email.length - 1));
};

export function isValidSession(
  session: any,
): session is { user: { id: number; userType: string; userTypeId: number } } {
  return (
    session &&
    session.user &&
    typeof session.user.id === "number" &&
    typeof session.user.userType === "string" &&
    typeof session.user.userTypeId === "number"
  );
}
